import React from "react";

const ITEMS = [
  "Slow-Roasted",
  "★",
  "Small Batches",
  "★",
  "Farm-Fresh Ingredients",
  "★",
  "Byadgi Chilies",
  "★",
  "No Preservatives",
  "★",
  "Karnataka Recipes",
  "★",
];

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div
      className="bg-[#2F4F2F] text-stone-50 py-4 overflow-hidden border-y border-stone-900/20"
      data-testid="marquee-strip"
    >
      <div className="flex animate-marquee whitespace-nowrap gap-10 min-w-max">
        {doubled.map((t, i) => (
          <span
            key={i}
            className={`font-serif text-lg md:text-xl italic ${
              t === "★" ? "text-[#f2c15b] not-italic font-sans" : ""
            }`}
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
